import React from "react";
import { Col, Row } from "react-bootstrap";

const LiabilityWaiver = () => {
  const darkModeStyles = {
    container: {
      backgroundColor: "#121212",
      color: "#ffffff",
      padding: "1rem",
      borderRadius: "5px",
    },
    header: {
      fontSize: "23px",
      textAlign: "center",
    },
    sectionHeader: {
      fontSize: "20px",
      fontWeight: "bold",
      marginTop: "1rem",
    },
    paragraph: {
      whiteSpace: "pre-line",
    },
    logo: {
      filter: "invert(100%)",
    },
  };

  return (
    <div className="container my-4">
      <div className="d-flex flex-column justify-content-center align-items-center auth px-0 w-100">
        <Row className="w-100 mx-0">
          <Col lg={12} md={12} sm={12} className="mx-auto">
            <div
              className="auth-form-light text-left py-5 px-4 px-sm-5"
              style={darkModeStyles.container}
            >
              <div className="brand-logo d-flex">
                <img
                  className="mx-auto"
                  src={require("../../../../assets/images/logo.png")}
                  alt="logo"
                  // style={darkModeStyles.logo}
                />
              </div>

              {/* <p>
                <b style={darkModeStyles.header}>
                  <center>SK8 GYM App - Liability Waiver</center>
                </b>
              </p> */}

              <div style={darkModeStyles.paragraph}>
                <p style={darkModeStyles.sectionHeader}>
                  LIABILITY RELEASE WAIVER
                </p>

                <p>
                  I, the parent/person having legal custody/guardianship of the
                  above said minor, give permission for the minor and/or myself
                  to participate in skating with SK8 GYM, Corporation. I and/or
                  my minor am/are physically able to participate in
                  skating-related activities. In consideration of me and/or my
                  minor being permitted to participate in any and all programs
                  as well as the use of facilities and/or equipment I, on behalf
                  of myself and/or as parent, guardian of participant, hereby:
                </p>

                <p>
                  1. Acknowledge that I have read this document, I have
                  inspected the facilities and equipment, I accept them as being
                  safe and reasonably suited for the purposes intended, and I
                  voluntarily accept the terms and conditions of this document.
                </p>

                <p>
                  2. Release SK8 GYM, Corporation, its directors, officers,
                  employees, agents, representatives, and volunteers
                  (collectively "releases") from all liability for any loss or
                  damages to property or injury or death to me and/or my minor,
                  whether caused by Releases or otherwise and while such
                  participant is in attendance of SK8 GYM, Corporation.
                </p>

                <p>
                  3. I agree not to sue Releases for any loss, damage, injury,
                  or death described above and I will indemnify and hold
                  harmless Releases and each of them from any loss, liability,
                  damage, or cost they may incur due to me and/or my minor’s
                  presence in attendance of SK8 GYM, Corporation, whether caused
                  by the negligence of the Releases or otherwise.
                </p>

                <p>
                  4. I assume full responsibility for risk of bodily injury,
                  death, or personal property damage due to the negligence of
                  the Releases or otherwise.
                </p>

                <p>
                  5. I do hereby authorize SK8 GYM, Corporation as agent for the
                  undersigned, to consent with respect to said minor, to any
                  x-ray examination, anesthetic, medical, dental, or surgical
                  diagnosis or treatment, and hospital care which is deemed
                  advisable by and is to be rendered under general or special
                  supervision of any physician and surgeon licensed under the
                  provisions of the Medical Practice Act on the medical staff of
                  any hospital, whether such diagnosis or treatment is rendered
                  at the office of the physician or the hospital. I understand
                  that SK8 GYM, Corporation is not responsible for any costs
                  incurred for medical care.
                </p>

                <p>
                  I HAVE READ AND UNDERSTOOD THIS AGREEMENT, AND I AM AWARE THAT
                  I AM WAIVING CERTAIN LEGAL RIGHTS WHICH I OR MY HEIRS, NEXT OF
                  KIN, EXECUTORS, ADMINISTRATORS, AND ASSIGNS MAY HAVE AGAINST
                  THE RELEASEES.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default LiabilityWaiver;
